import { useState } from "react";
import { CloseEyesIcon, LockIcon, OpenEyesIcon } from "../../assets/icons";

const InputPass = ({ ...rest }) => {
  const [showPass, setShowPass] = useState(false);

  return (
    <div className="gm-login-form-group">
      <label htmlFor="pass">
        <input type={showPass ? "text" : "password"} {...rest} />
      <LockIcon />
        <button
          type="button"
          onClick={() => {
            setShowPass(!showPass);
          }}
          className="gm-eye-svg"
        >
          {showPass ? (
            <OpenEyesIcon />
          ) : (
            <CloseEyesIcon />
          )}
        </button>
      </label>
    </div>
  );
};

export default InputPass;
